module.exports = __webpack_public_path__ + "img/ic_mpe_musicbg.9.199d2b3e.png";